export const UPDATE_SITES_COUNT = "UPDATE_SITES_COUNT";
export const UPDATE_SAMEDAY_VISIT = "UPDATE_SAMEDAY_VISIT";
export const CLEAR_QUOTE_SITES = "CLEAR_QUOTE_SITES";
